import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { SeFeThemesLoader } from 'se-fe-themes';

enum ModalType {
  Exchange = 'exchange',
  LinkedSale = 'linked_sale',
  BulkLinkedSale = 'bulk_linked_sale'
}

@Component({
  selector: 'child-sale-element',
  templateUrl: './child-sale.component.html',
  styleUrls: ['./child-sale.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ChildSaleComponent implements OnInit {
  @Output() closeChildSaleModal = new EventEmitter<any>();
  @Output() success = new EventEmitter<any>();
  @Input() parent_sale_id: number;
  @Input() modal_type: ModalType = ModalType.Exchange;
  @Input() salesperson_full_name: string;
  @Input() sales_number: string;
  @Input() org_id: string;
  @Input() processing_fee: string;
  @Input() transaction_fee: string;
  @Input() service_fee_definition_method: string;
  @Input() shared_org_rate: string;
  @Input() shared_org_payment_plan_fee: string;
  @Input() shared_member_rate: string;
  @Input() shared_member_payment_plan_fee: string;

  private _parent_sales: Array<number | (Record<string, unknown> & { id: number })> = [];

  @Input()
  set parent_sales(value: any) {
    if (typeof value === 'string') {
      try { this._parent_sales = JSON.parse(value); } catch { this._parent_sales = []; }
    } else {
      this._parent_sales = value || [];
    }
  }
  get parent_sales() { return this._parent_sales; }

  public MT = ModalType;

  constructor() {
    SeFeThemesLoader.load({
      supportedThemes: 'light',
      url: 'https://se-fe-angular-services.ui.sportngin.com'
    });
  }

  ngOnInit(): void {}
  
  public closeModal(): void { 
    this.resetModal();
    this.closeChildSaleModal.emit(true);
  }

  public submit(result?: any): void {
    this.success.emit(result ?? true);
  }

  private resetModal(): void { }
}
